import { useState, FC } from 'react';
import { NextgenDOMPurify } from '@nextgen-web-framework/all';
import type { FullScreenBannerProps } from './types/propsTypes';
import FullScreenModal from './FullScreenModal';
import styles from './FullScreenBanner.module.scss';

const FullScreenBanner: FC<FullScreenBannerProps> = (data) => {
  const [showModal, setShowModal] = useState(true);
  const contentArea = data.sanitize ? NextgenDOMPurify(data.content, data.sanitizationConfig) : data.content;
  const onTextModalClose = () => {
    setShowModal(false);
  };

  return (
    <div className={styles['full-screen-banner']} data-testid="full-screen-banner-container-id">
      {showModal && (
        <FullScreenModal onClose={onTextModalClose} data-testid="full-screen-banner-modal-id">
          <div dangerouslySetInnerHTML={{ __html: contentArea }}></div>
        </FullScreenModal>
      )}
    </div>
  );
};

export default FullScreenBanner;
